import axios from 'axios';

const FETCH_PACKAGE = '/FETCH_PACKAGE';
const FETCH_ERROR_PACKAGE = '/FETCH_ERROR_PACKAGE';
const SET_REDIRECT_URL = '/SET_REDIRECT_URL';

const projectOne = {
  namespaced: true,
  state: {
    redirectUrl: '',
    package: {
      data: {},
      error: null,
    },
  },
  getters: {
    package: (state) => state.package.data,
    platform: (state) => state.package.data.platform,
    redirectUrl: (state) => state.redirectUrl,
  },
  mutations: {
    [FETCH_PACKAGE](state, payload) {
      state.package.data = payload;
      state.package.error = null;
    },
    [FETCH_ERROR_PACKAGE](state, payload) {
      state.package.data = null;
      state.package.error = payload;
    },
    [SET_REDIRECT_URL](state, payload) {
      state.redirectUrl = payload;
    },
  },
  actions: {
    setRedirectUrl({commit}, payload) {
      commit(SET_REDIRECT_URL, payload);
    },
    async fetchPackage({commit, state}, payload) {
      if (payload) {
        try {
          const response = await axios.get(`/project-one/api/packages/${payload}`);
          console.log('packages API response data: ' + JSON.stringify(response.data.data, null, 1)); //TODO: Remove before P1 launch
          if (response.status === 200) {
            commit(FETCH_PACKAGE, response.data.data);
            return response.status;
          } else {
            /* handle invalid packageId case */
            commit(FETCH_ERROR_PACKAGE, response);
            window.location.href = state.redirectUrl;
            return response.status;
          }
        } catch (error) {
          commit(FETCH_ERROR_PACKAGE, error);
          window.location.href = state.redirectUrl;
          return error;
        }
      } else {
        // if packageId is missing redirect
        window.location.href = state.redirectUrl;
      }
    },
  },
};

export default projectOne;
